import { Route, Routes } from "react-router-dom";

import CarreraNegociosMetodologia from "../newPages/carreras/CarreraNegociosMetodologia";
import CarreraRecursosNaturales from "../newPages/carrerasnew/CarreraRecursosNaturales";
import CarreraRiesgos from "../newPages/carrerasnew/CarreraRiesgos";
import CarreraEnergia from "../newPages/carrerasnew/CarreraEnergia";

import CarreraNegociosInternacionales from "../newPages/carrerasnew/CarreraNegociosInternacionales";
import CarreraGovTech from "../newPages/carrerasnew/CarreraGovTech";
import CarreraNegociosTuristicos from "../newPages/carrerasnew/CarreraNegociosTuristicos";
import CarreraRedes from "../newPages/carrerasnew/CarreraRedes";
import CarreraAdministracionEmpresas from "../newPages/carrerasnew/CarreraAdministracionEmpresas";
import CarreraGastronomia from "../newPages/carrerasnew/CarreraGastronomia";
import CarreraAgronegocios from "../newPages/carrerasnew/CarreraAgronegocios";
import CarreraCienciasPoliticas from "../newPages/carrerasnew/CarreraCienciasPoliticas";
import CarreraComunicacion from "../newPages/carrerasnew/CarreraComunicacion";
import CarreraContabilidad from "../newPages/carrerasnew/CarreraContabilidad";
import CarreraDerecho from "../newPages/carrerasnew/CarreraDerecho";

function RoutesCarreras() {
  return (
    <>
      <Routes>
        <Route
          path="/carrera-recursos-naturales"
          element={<CarreraRecursosNaturales></CarreraRecursosNaturales>}
        />

        <Route path="/carrera-riesgos-online" element={<CarreraRiesgos />} />

        <Route path="/carrera-energia-online" element={<CarreraEnergia />} />

        <Route
          path="/carrera-negocios-internacionales"
          element={<CarreraNegociosInternacionales />}
        />

        <Route
          path="/carrera-govtech-online"
          element={<CarreraGovTech></CarreraGovTech>}
        />

        <Route
          path="/carrera-negocios-turisticos"
          element={<CarreraNegociosTuristicos />}
        />
      
        <Route
          path="/carrera-administracion-empresas"
          element={<CarreraAdministracionEmpresas />}
        />

        <Route path="/carrera-gastronomia" element={<CarreraGastronomia />} />
        <Route path="/carrera-redes" element={<CarreraRedes />} />
        <Route path="/carrera-agronegocios" element={<CarreraAgronegocios />} />
        <Route
          path="/carrera-ciencias-politicas"
          element={<CarreraCienciasPoliticas />}
        />

          <Route
          path="/carrera-comunicacion"
          element={<CarreraComunicacion />}
        />

        
          <Route
          path="/carrera-contabilidad-auditoria"
          element={<CarreraContabilidad />}
        />

          <Route
          path="/carrera-derecho"
          element={<CarreraDerecho />}
        />
      </Routes>{" "}
    </>
  );
}

export default RoutesCarreras;
